import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { ShieldCheck } from "lucide-react";

export default function ForcePrivacyConsent() {
  const { user, refreshUser } = useAuth();
  const [agreed, setAgreed] = useState(false);
  const [saving, setSaving] = useState(false);

  if (!user || !user.needs_privacy_consent) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!agreed) return toast.error("Please tick the box to agree to the Privacy Policy.");
    setSaving(true);
    try {
      await api.post("/auth/accept-privacy");
      toast.success("Thank you — consent recorded.");
      await refreshUser();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={true}>
      <DialogContent className="[&>button]:hidden" data-testid="force-privacy-dialog">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <div className="h-10 w-10 rounded-xl flex items-center justify-center" style={{ background: "#0B5E4E1A" }}>
              <ShieldCheck className="h-6 w-6" style={{ color: "var(--sj-primary)" }} />
            </div>
            <DialogTitle className="font-head text-2xl">Your privacy matters</DialogTitle>
          </div>
        </DialogHeader>
        <p className="text-sm mt-1" style={{ color: "var(--sj-text-2)" }}>
          We've updated how we look after your personal data. To continue, please review and agree to our Privacy &amp; Data Protection Policy. This is a one-time step.
        </p>
        <form onSubmit={submit} className="space-y-4 mt-3">
          <label className="flex items-start gap-2.5 text-sm cursor-pointer" style={{ color: "var(--sj-text-2)" }}>
            <input
              data-testid="force-privacy-checkbox"
              type="checkbox"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              className="mt-0.5 h-4 w-4 rounded accent-[#0B5E4E] shrink-0"
            />
            <span>
              I agree to the{" "}
              <a href="/privacy" target="_blank" rel="noreferrer" data-testid="force-privacy-link" className="font-semibold hover:underline" style={{ color: "var(--sj-primary)" }}>
                Privacy &amp; Data Protection Policy
              </a>.
            </span>
          </label>
          <button type="submit" disabled={saving || !agreed} data-testid="force-privacy-submit"
            className="w-full flex items-center justify-center gap-2 rounded-full px-6 py-2.5 text-white font-semibold hover:brightness-105 disabled:opacity-60" style={{ background: "var(--sj-primary)" }}>
            <ShieldCheck className="h-4 w-4" /> {saving ? "Saving..." : "Agree & continue"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
